"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("../../../theme/makeStyles");
exports.default = (0, makeStyles_1.makeStyles)(function (theme) {
    var _a, _b, _c, _d, _e, _f;
    return ({
        CTA: (_a = {
                width: '100%',
                display: 'flex',
                flexDirection: 'column-reverse',
                marginTop: '48px',
                paddingRight: '11px'
            },
            _a["@media only screen and (min-width: ".concat(theme.breakpoints.medium, "px)")] = {
                flexDirection: 'row',
                justifyContent: 'end',
                textAlign: 'right',
                display: 'unset',
                paddingRight: 0
            },
            _a),
        secondaryCTA: (_b = {
                marginTop: 12
            },
            _b["@media only screen and (min-width: ".concat(theme.breakpoints.medium, "px)")] = {
                marginRight: 20,
                marginTop: 0
            },
            _b),
        description: {
            marginTop: theme.spacing('small')
        },
        body: {
            marginTop: theme.spacing('xlarge'),
            flexGrow: 1
        },
        titleText: (_c = {
                paddingTop: '19px'
            },
            _c["@media only screen and (min-width: ".concat(theme.breakpoints.medium, "px)")] = {
                paddingTop: '0'
            },
            _c),
        content: (_d = {
                display: 'flex',
                flexDirection: 'column',
                padding: [theme.spacing('large')],
                width: '100%',
                height: '100%'
            },
            _d["@media only screen and (min-width: ".concat(theme.breakpoints.medium, "px)")] = {
                padding: "\n        ".concat(theme.spacing('xxlarge'), "\n        ").concat(theme.spacing('xlarge'), "\n      "),
                maxHeight: '100vh'
            },
            _d),
        close: {
            position: 'absolute',
            color: 'inherit',
            borderRadius: '50%',
            top: 0,
            right: 0,
            width: '32px',
            height: '32px',
            margin: theme.spacing('medium'),
            font: 'inherit',
            cursor: 'pointer',
            alignSelf: 'end',
            paddingTop: '3px',
            border: 'none',
            backgroundColor: theme.colors.white
        },
        image: (_e = {
                objectFit: 'cover',
                height: '250px'
            },
            _e["@media only screen and (min-width: ".concat(theme.breakpoints.medium, "px)")] = {
                width: '33%',
                height: 'unset'
            },
            _e),
        stopScroll: {
            overflow: 'hidden'
        },
        root: (_f = {
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
                backgroundColor: theme.colors.white,
                margin: [theme.spacing('xxlarge'), 'auto', 0, 'auto'],
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                overflowY: 'scroll',
                height: "calc(100vh - ".concat(theme.spacing('xxlarge'), ")")
            },
            _f["@media only screen and (min-width: ".concat(theme.breakpoints.medium, "px)")] = {
                margin: '90px auto 0  auto',
                overflowY: 'unset',
                maxWidth: '816px',
                flexDirection: 'row',
                height: 'unset',
                '&::before': {
                    display: 'none'
                }
            },
            _f)
    });
});
